import ScoreTable from './components/ScoreTable'

const ScoreTablePage: React.FC = () => (
  <div className="h-full min-h-screen bg-gray-200 p-8">
    <ScoreTable />
  </div>
)

export default ScoreTablePage
